var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"wrap":""}},_vm._l((_vm.cards),function(card){return _c('v-col',{key:card._id,attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('Card',{attrs:{"card":card}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }